/**
 * throughParams array,数组每个值为一个object
 * object param:
 * @param {field} [String] - 字段名称
 * @param {op} [String] - 规则
 * @param {type} [String] - 参数类型 [cParams / filtersParams]
 */
export const orderMenu = [
	{
		orderType: '商户报表',
		key: 'MID_DPXQ_121011',
		label: '单据详情',
		path: 'orderDetailSupply',
		throughPath: '',
		throughParams: []
	}, {
		orderType: '商户报表',
		key: 'MID_DPDD_121010',
		label: '单据销售汇总',
		path: 'saleOrderSupply',
		throughPath: 'orderDetailSupply',
		throughParams: [
			{ field: 'orderNo', op: 'cn', type: 'cParams' },
			{ field: 'orderType', op: 'eq', type: 'cParams' },
			{ field: 'entName', op: 'cn', type: 'filtersParams' },
			{ field: 'shopName', op: 'cn', type: 'filtersParams' }
		]
	}, {
		orderType: '商户报表',
		key: 'MID_DPHZ_121040',
		label: '店铺销售汇总',
		path: 'shopSummarySupply',
		throughPath: 'saleOrderSupply',
		throughParams: [
			{ field: 'entname', op: 'cn', type: 'filtersParams' },
			{ field: 'shopName', op: 'cn', type: 'filtersParams' }
		]
	}, {
		orderType: '商户报表',
		key: 'MID_SHHZ_111040',
		label: '商户销售汇总',
		path: 'businessSummarySupply',
		throughPath: 'shopSummarySupply',
		throughParams: [
			{ field: 'entname', op: 'cn', type: 'filtersParams' }
		]
	}, {
		orderType: '商户报表',
		key: 'MID_SPXS_131040',
		label: '商品销售汇总',
		path: 'businessPurchaseSupply',
		throughPath: '',
		throughParams: []
	}, {
		orderType: '平台报表',
		authority: '09_0003_0001_00',
		show: false,
		key: 'PAY_ZFDZ_000006',
		label: '单据支付对账明细表',
		path: 'orderPayment',
		throughPath: 'orderResume',
		throughParams: [
			{ field: 'ordernumber', op: 'cn', type: 'filtersParams' },
			{ field: 'refundnumber', op: 'cn', type: 'filtersParams' }
		]
	},
	{
		orderType: '平台报表',
		authority: '09_0003_0002_00',
		show: false,
		key: 'PAY_ZFLS_000007',
		label: '支付流水报表',
		path: 'transaction',
		throughPath: 'orderResume',
		throughParams: [
			{ field: 'ordernumber', op: 'cn', type: 'cParams' }
		]
	},
	{
		orderType: '平台报表',
		authority: '09_0003_0003_00',
		show: false,
		key: 'PREPAY_YFMX_000008',
		label: '预付货款明细表',
		path: 'paymentAdvance',
		throughPath: '',
		throughParams: []
	}]

